export default {
    setInfo: data => {
        return {
            type: 'SET_APP_INFO',
            data
        };
    }
};



// WEBPACK FOOTER //
// ./src/actions/app.js